export default "__VITE_ASSET__49abd857__"